export class FetchUpdates {
  static readonly type = '[Catalogs] Fetch Updates';
  constructor() {}
}
